import { SummaryStatsCard } from '@exam-center/components';
import { useExamDistributionByMonth } from '@exam-center/exam-distribution';
import { Flex } from '@shared/components';

export default function ExamDistributionSummaryStatuses() {
  const { examDistributionSummaryData, isLoading } = useExamDistributionByMonth();
  const { totalCount, unassignedCount, publicCount, inHouseCount, cancelCount } =
    examDistributionSummaryData;

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
      <SummaryStatsCard
        title='จำนวนรอบสอบทั้งหมด'
        displayValue={`${totalCount} รอบ`}
        loading={isLoading}
      />
      <SummaryStatsCard
        title='รอบสอบที่ยังไม่ได้ Assign'
        displayValue={`${unassignedCount} รอบ`}
        color='info'
        loading={isLoading}
      />
      <SummaryStatsCard
        title='Public'
        displayValue={`${publicCount} รอบ`}
        color='success'
        loading={isLoading}
      />
      <SummaryStatsCard
        title='In-house'
        displayValue={`${inHouseCount} รอบ`}
        color='warning'
        loading={isLoading}
      />
      <SummaryStatsCard
        title='รอบสอบที่ยกเลิก'
        displayValue={`${cancelCount} รอบ`}
        color='error'
        loading={isLoading}
      />
    </Flex>
  );
}
